import {TeemillError} from './teemillError';

export class EventBusTimeoutError extends TeemillError {
  constructor(eventName: string) {
    super(`Event: '${eventName}' timed out`);
  }
}
